@if (showBottomNav) {
  <mat-toolbar id="navigation-bar">
    <nav mat-tab-nav-bar backgroundColor="primary">
      @for (link of links; track link) {
        <a mat-tab-link [routerLink]="link.href" [active]="activeLinkIndex === link.index">
          <div class="nav-content">
            <mat-icon [svgIcon]="link.icon" [inline]="true"></mat-icon>
            @if (link.label === 'Messages' && showUrgentMessageIcon) {
              <mat-icon class="mat-important-icon mat-important-icon-mobile"
                svgIcon="important"
              [inline]="true"></mat-icon>
            }
            @if (link.label === 'Messages' && showNewMessageNotification) {
              <mat-icon class="mat-circle-icon mat-circle-icon-mobile"
                svgIcon="circle"
              [inline]="true"></mat-icon>
            }
            <span>{{link.label}}</span>
          </div>
        </a>
      }
    </nav>
  </mat-toolbar>
}
@if (showLeftNav) {
  <mat-sidenav-container>
    <mat-sidenav #sidenav mode="side" opened="true">
      <mat-nav-list>
        @for (link of links; track link) {
          <mat-list-item class="side-nav-list-items" [routerLink]="link.href"
            [class.active]="activeLinkIndex === link.index">
            <mat-icon [svgIcon]="link.icon" [inline]="true" />
            @if (link.label === 'Messages' && showUrgentMessageIcon) {
              <mat-icon class="mat-important-icon mat-important-icon-sidenav"
                svgIcon="important"
              [inline]="true" />
            }
            @if (link.label === 'Messages' && showNewMessageNotification) {
              <mat-icon class="mat-circle-icon mat-circle-icon-sidenav"
                svgIcon="circle"
              [inline]="true" />
            }
            <span>{{link.label}}</span>
          </mat-list-item>
        }
      </mat-nav-list>
    </mat-sidenav>
  </mat-sidenav-container>
}